var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "relative inline-block text-left" },
    [
      _c("div", { staticClass: "flex items-center" }, [
        _c(
          "button",
          {
            staticClass:
              "ml-6 inline-flex items-center capitalize text-xs font-semibold  rounded-full leading-none px-2 py-1 lg:text-xs",
            class: [
              _vm.currentStatus === "active"
                ? "text-green-700 bg-green-200"
                : "text-gray-700 bg-gray-200"
            ],
            attrs: { type: "button" },
            on: {
              click: function($event) {
                _vm.isOpen = !_vm.isOpen
              }
            }
          },
          [
            _vm._v(" " + _vm._s(_vm.currentStatus) + " "),
            _c(
              "svg",
              {
                staticClass: "-mr-1  h-4 w-4",
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 20 20",
                  fill: "currentColor",
                  "aria-hidden": "true"
                }
              },
              [
                _c("path", {
                  attrs: {
                    "fill-rule": "evenodd",
                    d:
                      "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
                    "clip-rule": "evenodd"
                  }
                })
              ]
            )
          ]
        )
      ]),
      _c(
        "transition",
        {
          attrs: {
            "enter-active-class": "transition ease-out duration-100 transform",
            "enter-class": "opacity-0 scale-95",
            "enter-to-class": "opacity-100 scale-100",
            "leave-active-class": "transition ease-in duration-75 transform",
            "leave-class": "opacity-100 scale-100",
            "leave-to-class": "opacity-0 scale-95"
          }
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isOpen,
                  expression: "isOpen"
                }
              ],
              staticClass:
                "origin-top-right absolute left-0 mt-2 w-56 rounded-md shadow-lg z-10"
            },
            [
              _c(
                "div",
                {
                  staticClass: "rounded-md bg-white shadow-xs",
                  attrs: {
                    role: "menu",
                    "aria-orientation": "vertical",
                    "aria-labelledby": "options-menu"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "py-1" },
                    _vm._l(_vm.statuses, function(status, index) {
                      return _c(
                        "a",
                        {
                          key: index,
                          staticClass:
                            "block px-4 py-2 text-xs leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900",
                          attrs: { role: "menuitem" },
                          on: {
                            click: function($event) {
                              return _vm.onItemClicked(status.value)
                            }
                          }
                        },
                        [_vm._v(_vm._s(status.name) + " ")]
                      )
                    }),
                    0
                  ),
                  _c("div", { staticClass: "border-t border-gray-100" })
                ]
              )
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }